export const API_URL = import.meta.env.VITE_API_URL || '/api/v1';

// Derive WebSocket URL from current page protocol and host so it routes through nginx proxy
// Handle test environment where window is not defined
const _wsProtocol = typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'wss:' : 'ws:';
const _wsHost = typeof window !== 'undefined' ? window.location.host : 'localhost:8000';
export const WS_URL = import.meta.env.VITE_WS_URL || `${_wsProtocol}//${_wsHost}`;